/**
 * Projects Services Module
 * Exports all project management services and factory functions
 */
// Project Management Service exports
export * from './ProjectService';
export * from './ProjectStatusService';
export * from './ProjectTypeService';
export * from './ProjectAuditLogService';
export * from './ProjectMessageService';
export * from './ProjectMilestoneService';
export * from './ProjectMilestoneTaskService';
export * from './ProjectRiskService';
export * from './ProjectTeamMemberService';
export * from './TaskTimeLogService';
export * from './ProjectResourceService';
export * from './ProjectDocumentService';
export * from './PlannedBudgetItemService';
export * from './TaskDependencyService';
export * from './ResourceTypeService';
export * from './ProjectRoleService';
export * from './BudgetLineItemService';
// Project Management service imports for factory
import { ProjectService } from './ProjectService';
import { ProjectStatusService } from './ProjectStatusService';
import { ProjectTypeService } from './ProjectTypeService';
import { ProjectAuditLogService } from './ProjectAuditLogService';
import { ProjectMessageService } from './ProjectMessageService';
import { ProjectMilestoneService } from './ProjectMilestoneService';
import { ProjectMilestoneTaskService } from './ProjectMilestoneTaskService';
import { ProjectRiskService } from './ProjectRiskService';
import { ProjectTeamMemberService } from './ProjectTeamMemberService';
import { TaskTimeLogService } from './TaskTimeLogService';
import { ProjectResourceService } from './ProjectResourceService';
import { ProjectDocumentService } from './ProjectDocumentService';
import { PlannedBudgetItemService } from './PlannedBudgetItemService';
import { TaskDependencyService } from './TaskDependencyService';
import { ResourceTypeService } from './ResourceTypeService';
import { ProjectRoleService } from './ProjectRoleService';
import { BudgetLineItemService } from './BudgetLineItemService';
/**
 * Create all projects services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all projects service instances
 */
export function createProjectsServices(http, config) {
    return {
        project: new ProjectService(http, config),
        projectStatus: new ProjectStatusService(http, config),
        projectType: new ProjectTypeService(http, config),
        projectAuditLog: new ProjectAuditLogService(http, config),
        projectMessage: new ProjectMessageService(http, config),
        projectMilestone: new ProjectMilestoneService(http, config),
        projectMilestoneTask: new ProjectMilestoneTaskService(http, config),
        projectRisk: new ProjectRiskService(http, config),
        projectTeamMember: new ProjectTeamMemberService(http, config),
        taskTimeLog: new TaskTimeLogService(http, config),
        projectResource: new ProjectResourceService(http, config),
        projectDocument: new ProjectDocumentService(http, config),
        plannedBudgetItem: new PlannedBudgetItemService(http, config),
        taskDependency: new TaskDependencyService(http, config),
        resourceType: new ResourceTypeService(http, config),
        projectRole: new ProjectRoleService(http, config),
        budgetLineItem: new BudgetLineItemService(http, config),
    };
}
//# sourceMappingURL=index.js.map